<template>
  <div id="configuratorNavigation">
    <div id="configuratorTopBar" class="configurator-topbar">
      <div class="configurator-topbar-slide-group">
        <div class="configurator-topbar-area" id="topBarLogoArea"></div>
        <div class="configurator-topbar-area" id="topBarButtonArea">
          <Button
            p_label=" "
            v-bind:p_disabled="p_isLeftButtonDisabled"
            p_customId="backButton"
            p_iconLeft="fal fa-arrow-left"
            p_customClass="secondary-button"
          />
          <Button
            p_label=" "
            v-bind:p_disabled="p_isRightButtonDisabled"
            p_customId="nextButton"
            p_iconRight="fal fa-arrow-right"
            p_customClass="secondary-button"
          />
          <div v-if="!p_isPriceOnRequest" class="configurator-price-element">
            <span class="configurator-price-element-headline">
              Aktueller Preis
            </span>
            <div id="lowerPart">
              <span
                id="configuratorPrice"
                class="configurator-price-element-price"
                v-bind:class="
                  p_isPriceCalculating
                    ? 'fade-in-price-text'
                    : 'fade-out-price-text'
                "
              >
                {{ p_priceText }}
              </span>
              <span class="configurator-price-element-subheadline text-small">
                inklusive MwSt. und Versand
              </span>
            </div>
          </div>
          <div v-if="p_isPriceOnRequest" class="configurator-price-element">
            <span class="configurator-price-element-headline"> </span>
            <div id="lowerPart">
              <span
                id="configuratorPrice"
                class="configurator-price-element-price"
              >
                Preis auf Anfrage
              </span>
              <span class="configurator-price-element-subheadline text-small">
              </span>
            </div>
          </div>
        </div>
      </div>
      <div class="configurator-topbar-area" id="topBarMenuEntriesArea">
        <menu-item
          v-if="p_showPGSwitch"
          v-show="isKPressed"
          p_label="K"
          p_customId="custom-button-k"
          p_customClass="configurator-button topbar-button secondary-button custom-button-activated"
        />
        <menu-item
          v-if="p_showPGSwitch"
          v-show="!isKPressed"
          p_label="K"
          p_customId="custom-button-k"
          p_customClass="configurator-button topbar-button secondary-button"
        />
        <menu-item
          v-if="p_showPGSwitch"
          v-show="isPPressed"
          p_label="P"
          p_customId="custom-button-p"
          p_customClass="configurator-button topbar-button secondary-button custom-button custom-button-activated"
        />
        <menu-item
          v-if="p_showPGSwitch"
          v-show="!isPPressed"
          p_label="P"
          p_customId="custom-button-p"
          p_customClass="configurator-button topbar-button secondary-button custom-button"
        />
        <menu-item
          v-if="p_showSkip"
          v-bind:p_isDisabled="p_isSkipDisabled"
          p_label="<span id='customSkipLabelDesktop'>Schritt überspringen</span><span id='customSkipLabelMobile'>Überspringen</span>"
          p_customId="skipStepMenuItem"
          v-bind:p_customClass="c_customClassSkip"
          p_icon="fal fa-share"
        />
        <menu-item
          v-if="p_showHelp"
          p_label="Hilfe"
          p_customId="helpMenuItem"
          p_customClass="configurator-button topbar-button secondary-button"
          p_icon="fal fa-question-circle"
        />
        <menu-item
          p_label="Konfigurationen speichern / laden"
          p_customId="saveMenuItem"
          p_customClass="configurator-button topbar-button secondary-button"
          p_icon="fal fa-save"
        />
      </div>
    </div>
    <div
      class="configurator-progress-bar brand-color"
      id="stepProgressBar"
      v-bind:style="{ width: progressbarPercentage + '%' }"
    >
      <span></span>
    </div>
    <div id="configuratorTopBarMobile">
      <a id="openLeftMenu" href="javascript:void(0)" @click="openNav()">
        <i class="fas fa-bars"></i>Menü
      </a>
      <div
        v-if="false"
        id="configuratorPriceMobile"
        class="configurator-price-element"
      >
        <span
          v-if="!p_isPriceOnRequest"
          class="configurator-price-element-price"
        >
          {{ p_priceText }}
        </span>
        <span
          v-if="p_isPriceOnRequest"
          class="configurator-price-element-price"
        >
          Preis auf Anfrage
        </span>
      </div>
    </div>
    <div class="dk-doorconfigurator-mobile-side-menu" id="leftMenu">
      <img
        href="https://www.shop.duschking.de/"
        id="doorconfiguratorMobileMenuLogo"
        src="https://shop.duschking.de/media/db/c2/eb/1708676633/duschking-logo.svg"
        alt="duschking Logo"
      />
      <a
        href="https://www.shop.duschking.de/"
        class="dk-doorconfigurator-mobile-menu-elem"
        ><i class="fal fa-home"></i><span>Zur Startseite</span></a
      >
      <a
        @click="openHelpModalMobile()"
        class="dk-doorconfigurator-mobile-menu-elem"
        ><i class="fal fa-question-circle"></i><span>Hilfe</span></a
      >
      <a
        @click="openSaveModalMobile()"
        class="dk-doorconfigurator-mobile-menu-elem"
        ><i class="fal fa-save"></i
        ><span>Konfiguration speichern oder laden</span></a
      >
      <a
        v-if="p_showSkip"
        @click="skipStep()"
        class="dk-doorconfigurator-mobile-menu-elem"
        ><i class="fal fa-share"></i><span>Schritt überspringen</span></a
      >
    </div>

    <div id="doorconfiguratorMobileBackgroundOverlay" @click="closeNav()"></div>

    <div class="dk-doorconfigurator-mobile-bottombar">
      <div
        class="dk-doorconfigurator-mobile-bottombar-button"
        @click="showPrevStep"
        p_customId="backButtonMobile"
      >
        <i class="fal fa-chevron-left"></i>Zurück
      </div>
      <div
        class="dk-doorconfigurator-mobile-bottombar-button"
        id="openStepOverview"
        @click="showStepBar"
      >
        <i class="fal fa-list-ul"></i>Übersicht
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
.dk-doorconfigurator-mobile-side-menu {
  height: 100%;
  width: 0px;
  position: fixed;
  z-index: 120;
  top: 0;
  left: 0;
  background-color: rgba(255, 255, 255, 1);
  overflow-x: hidden;
  padding-top: 20px;
  opacity: 0;
  -webkit-transition: width 0.3s ease, opacity 0.1s ease;
  -moz-transition: width 0.3s ease, opacity 0.1s ease;
  -ms-transition: width 0.3s ease, opacity 0.1s ease;
  -o-transition: width 0.3s ease, opacity 0.1s ease;
  transition: width 0.3s ease, opacity 0.1s ease;
  &#leftMenu {
  }
  &#rightMenu {
    left: initial;
    right: -30px;
    padding: 20px 15px;
    &.open {
      right: 0px;
    }
    .mobile-left-menu-head {
      //white-space: nowrap;
      margin: 20px 10px;
    }
    .mobile-left-menu-description {
      font-size: 14px !important;
      color: blue;
      min-width: 220px;
      width: 220px;
      overflow: hidden;
      text-overflow: ellipsis; //margin: 10px 10px 20px;
    }
    .dk-doorconfigurator-stepbar-step-wrapper {
      margin: 0 10px;
      .hbtr-doorconfigurator-stepbar-step-container {
        margin-bottom: 10px;
        padding-bottom: 10px;
        border-bottom: 1px solid #818181;
        display: flex;
        flex-wrap: nowrap;
        span.hbtr-doorconfigurator-stepbar-step {
          padding-left: 45px;
          white-space: nowrap;
        }
        i.hbtr-doorconfigurator-step-icon {
          left: 25px;
        }
      }
    }
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .dk-doorconfigurator-mobile-menu-elem {
    padding: 8px 8px 8px 5px;
    text-decoration: none;
    color: #818181;
    cursor: pointer;
    display: block;
    opacity: 0;
    transition: 0.3s;
    border-bottom: 2px solid #f5f5f5;
    margin: 0 15px; //white-space: nowrap;
    -webkit-transition: opacity 0.3s ease 0.2s;
    -moz-transition: opacity 0.3s ease 0.2s;
    -ms-transition: opacity 0.3s ease 0.2s;
    -o-transition: opacity 0.3s ease 0.2s;
    transition: opacity 0.3s ease 0.2s;
    display: flex;
    i {
      margin-right: 15px;
      margin-top: 4px;
    }
  }
  #doorconfiguratorMobileMenuLogo {
    height: 150px;
    width: 150px;
    opacity: 0;
    display: block;
    margin: 10px auto;
    -webkit-transition: opacity 0.5s ease 0.1s;
    -moz-transition: opacity 0.5s ease 0.1s;
    -ms-transition: opacity 0.5s ease 0.1s;
    -o-transition: opacity 0.5s ease 0.1s;
    transition: opacity 0.5s ease 0.1s;
  }
}

.dk-doorconfigurator-mobile-bottombar {
  position: fixed;
  display: none;
  width: 100vw;
  bottom: 0;
  left: 0;
  height: 55px;
  z-index: 100;
  border-top: 1px solid #818181;
  opacity: 1;
  -webkit-transform: translateY(0);
  -moz-transform: translateY(0);
  -ms-transform: translateY(0);
  -o-transform: translateY(0);
  transform: translateY(0);
  -webkit-transition: all 0.3s ease;
  -moz-transition: all 0.3s ease;
  -ms-transition: all 0.3s ease;
  -o-transition: all 0.3s ease;
  transition: all 0.3s ease;
  &.hidden {
    opacity: 0;
    -webkit-transform: translateY(60px);
    -moz-transform: translateY(60px);
    -ms-transform: translateY(60px);
    -o-transform: translateY(60px);
    transform: translateY(60px);
  }
  .dk-doorconfigurator-mobile-bottombar-button {
    height: 100%;
    width: 50%;
    background-color: white;
    border: none;
    padding: 13px 20px;
    text-align: center;
    -webkit-transition: all 0.2s ease;
    -moz-transition: all 0.2s ease;
    -ms-transition: all 0.2s ease;
    -o-transition: all 0.2s ease;
    transition: all 0.2s ease;
    border: 2px solid transparent;
    i {
      margin-right: 10px;
    }
    &#backButtonMobile {
      -webkit-border-radius: 10px 0 0 0;
      -moz-border-radius: 10px 0 0 0;
      border-radius: 10px 0 0 0;
      border-right: 2px solid #818181;
    }
    &#openStepOverview {
      -webkit-border-radius: 0 10px 0 0;
      -moz-border-radius: 0 10px 0 0;
      border-radius: 0 10px 0 0;
      border-left: 1px solid #818181;
    }
    &:focus {
      border: 1px solid #818181;
    }
    &:active {
      background-color: #818181;
    }
  }
}

.dk-doorconfigurator-mobile-side-menu.open {
  width: 250px;
  opacity: 1;
  #doorconfiguratorMobileMenuLogo {
    opacity: 1;
  }
  .dk-doorconfigurator-mobile-menu-elem {
    opacity: 1;
  }
}

.stepBarMobile {
  &.open {
    display: block;
  }
}

@media only screen and (max-width: 767px) {
  .dk-doorconfigurator-mobile-bottombar {
    display: flex;
  }
}
</style>

<script>
import Button from "./Button";
import MenuItem from "./MenuItem.vue";
import StepBar from "./Stepbar.vue";

export default {
  components: { Button, StepBar, MenuItem },
  props: {
    p_isLeftButtonDisabled: Boolean,
    p_isRightButtonDisabled: Boolean,
    p_steps: Array,
    p_priceText: String,
    p_showHelp: Boolean,
    p_isSkipDisabled: Boolean,
    p_isPriceOnRequest: Boolean,
    p_isPriceCalculating: Boolean,
    p_showSkip: Boolean,
    p_showPGSwitch: Boolean
  },
  data() {
    return {
      progressbarPercentage: 0,
      isKPressed: true,
      isPPressed: false
    };
  },
  computed: {
    c_customClassSkip: function() {
      if (this.p_isSkipDisabled) {
        return "configurator-button topbar-button secondary-button skip-button skip-button-disabled";
      }
      return "configurator-button topbar-button secondary-button skip-button brand-color";
    },
    c_notHiddenSteps: function() {
      return this.p_steps.filter(step => !step.isHidden);
    }
  },
  methods: {
    executeMenuItemButton(label) {
      let priceGroup = "EK";
      if (label.includes("Hilfe")) {
        this.$parent.setHelpVisibility(true);
      } else if (label.includes("speichern")) {
        this.$parent.setLoadSaveVisibility(true);
      } else if (label.includes("K")) {
        this.isPPressed = false;
        this.isKPressed = true;
        this.$store.commit("deleteSpecificStep", -50);
        this.$store.commit("addStepValue", {
          stepId: -50,
          stepIndex: -50,
          attributeId: -50,
          value: priceGroup
        });
        this.$parent.refreshProducts();
        this.$parent.refreshPrice();
      } else if (label.includes("P")) {
        priceGroup = document
          .getElementById("main")
          .getAttribute("data-customergroup");

        if (priceGroup == "" || priceGroup == null || priceGroup == undefined) {
          priceGroup = "H";
        }
        this.isPPressed = true;
        this.isKPressed = false;
        this.$store.commit("deleteSpecificStep", -50);
        this.$store.commit("addStepValue", {
          stepId: -50,
          stepIndex: -50,
          attributeId: -50,
          value: priceGroup
        });
        this.$parent.refreshProducts();
        this.$parent.refreshPrice();
      } else {
        this.$parent.skipStep();
      }
    },
    executeDisabledMenuItemButton(label) {
      if (label.includes("springen")) {
        this.$parent.showSkipInfoPopup();
      }
    },
    resetMenuItemButton() {
      this.executeMenuItemButton("K");
    },
    showNextStep() {
      this.$parent.showNextStep();
    },
    showPrevStep() {
      this.$parent.showPrevStep();
    },
    updateProgressBar(actualStepId) {
      if (actualStepId == -1) {
        this.progressbarPercentage = 98;
      } else {
        let notHiddenSteps = this.c_notHiddenSteps;
        let notHiddenStepIndex = -1;
        for (let i = 0; i < notHiddenSteps.length; ++i) {
          if (notHiddenSteps[i].id == actualStepId) {
            notHiddenStepIndex = i;
          }
        }
        this.progressbarPercentage =
          (100 * notHiddenStepIndex) / this.c_notHiddenSteps.length;
        if (this.progressbarPercentage > 98) {
          this.progressbarPercentage = 98;
        }
      }
    },
    showStepBar() {
      this.$parent.showStepBarMobile();
      $("#doorconfiguratorMobileBackgroundOverlay").fadeIn(600);
    },
    openNav() {
      $("#leftMenu").addClass("open");
      $("#doorconfiguratorMobileBackgroundOverlay").fadeIn(600);
    },
    closeNav() {
      $("#leftMenu").removeClass("open");
      this.$parent.hideStepBarMobile();
      $("#doorconfiguratorMobileBackgroundOverlay").fadeOut(600);
    },
    openSteps() {
      $("#rightMenu").addClass("open");
      $("#doorconfiguratorMobileBackgroundOverlay").fadeIn(600);
    },
    openHelpModalMobile() {
      this.$parent.setHelpVisibility(true);
    },
    openSaveModalMobile() {
      this.$parent.setLoadSaveVisibility(true);
    },
    skipStep() {
      $("#skipStepMenuItem").click();
    }
  }
};
</script>

<style language="css">
@import "../../scss/topbar/style.css";
</style>

<!--
<style language="less">
@import '../../scss/topbar/style.less';
</style>
-->



// WEBPACK FOOTER //
// src/components/configurator/Topbar.vue